import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// Phase 1: public marketing site only (header, footer, homepage, about,
// courses catalog, contact). The logged-in dashboard is not translated yet —
// any string not in these bundles just falls back to its English key.
export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "fr", label: "Français", shortLabel: "FR" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    detection: {
      // Checked in order: an explicit user choice (localStorage) first, then
      // the browser's own language, so a French browser gets French by
      // default but a manual switch always wins on the next visit.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "e1x-lang",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
